module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Creating Group</h1>\n';
 if(processing) { 
__p+='\n<div class="processing">\n    <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n    Creating Group...\n</div>\n';
 } else { 
__p+='\n<div class="processing done">\n    <img src="/static/icons/tick.svg" class="picon" /><br/>\n    Your group has been created. It will appear in the next few minutes.\n</div>\n<button class="btn-close button-secondary button">\n    Close\n</button>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/new_group_processing.html
// module id = 346
// module chunks = 0